import DiscreteSlider from './DiscreteSlider'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import HeaderSeparator from './HeaderSeparator'
import { IoMdSwap } from "react-icons/io"
import { lastYearRange } from '../constants'


function BasicSettingsSubstitutes({ settings, setSettings, loginStatus, expandMenuEffectStatus }) {


  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      margin: theme.spacing(0, 0, 0),
    },
    accordion: {
      backgroundColor: "transparent",
    },
    details: {
      padding: theme.spacing(0, 0, 0),
      margin: theme.spacing(0, 0, 0),
    },
    noSpace: {
      padding: theme.spacing(0, 0, 0),
      margin: theme.spacing(0, 0, 0),
    },
    firstSubHeader: {
      margin: theme.spacing(-1, 0, 1),
    },
    iconDown: {
      marginTop: theme.spacing(0.5),
    },
    middleSubHeader: {
      margin: theme.spacing(1, 0, 1),
    },
    titleBox: {
      margin: theme.spacing(0, 0, 0),
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      alignContent: "center",
    },
    iconBox: {
      margin: theme.spacing(0, 0, 0),
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      alignContent: "center",
      height: "100%",
      width: "40px",
    },
    icon: {
      color: theme.palette.primary.main,
      height: "100%",
      width: "30px",
      margin: theme.spacing(0, 1, 0, 0),
    },
  }))
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Accordion className={classes.accordion} elevation={0}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          classes={expandMenuEffectStatus.down ?
            { root: classes.noSpace, expandIcon: classes.iconDown } :
            { root: classes.noSpace }}
        >
          <div className={classes.titleBox}>
            <div className={classes.iconBox}>
              <IoMdSwap className={classes.icon} />
            </div>
            <Typography variant="h6" color="textPrimary" >Bank</Typography>
          </div>
        </AccordionSummary>
        <AccordionDetails className={classes.details}>
          <div className={classes.root}>
            <div className={classes.firstSubHeader}><HeaderSeparator><Typography variant="subtitle2" color="textSecondary" >Leistung {lastYearRange}</Typography></HeaderSeparator></div>
            <DiscreteSlider title="Viele Kicker Punkte" badge={!(loginStatus.loggedIn && loginStatus.pro)} disabledFlag={!(loginStatus.loggedIn && loginStatus.pro)} settings={settings} setSettings={setSettings} targetValueName="wSubLastSeasonPoints" tooltipText="Bewege den Slider weiter nach rechts, um dir auch für die Ersatzbank Top-Punktesammler aus der letzten Saison zu holen. Bedenke aber, dass diese Spieler häufig auch sehr hohe Kicker-Marktwerte haben." />
            <DiscreteSlider title="Gute &#8709;-Note" badge={!(loginStatus.loggedIn && loginStatus.pro)} disabledFlag={!(loginStatus.loggedIn && loginStatus.pro)} settings={settings} setSettings={setSettings} targetValueName="wSubLastSeasonAvgGrade" tooltipText="Bewege den Slider weiter nach rechts, wenn du für die Ersatzbank Wert auf eine gute Durchschnittsnote der letzten Saison legst. Damit erfasst du auch Topspieler, die letzte Saison zeitweise verletzt waren und nicht so viele Punkte sammeln konnten." />
            <DiscreteSlider title="Viele Einsätze" badge={!(loginStatus.loggedIn && loginStatus.pro)} disabledFlag={!(loginStatus.loggedIn && loginStatus.pro)} settings={settings} setSettings={setSettings} targetValueName="wSubLastSeasonAppear" tooltipText="Bewege den Slider weiter nach rechts, wenn du Dauerbrenner mit vielen Einsätzen in der letzten Saison auf der Ersatzbank möchtest." />
            <DiscreteSlider title="Viele Tore" badge={!(loginStatus.loggedIn && loginStatus.pro)} disabledFlag={!(loginStatus.loggedIn && loginStatus.pro)} settings={settings} setSettings={setSettings} targetValueName="wSubLastSeasonGoals" tooltipText="Bewege den Slider weiter nach rechts für die besten Torschützen der letzten Saison. Damit könntest du dir zum Beispiel torgefährliche Spieler von schwächeren Teams auf die Bank setzten" />
            <div className={classes.middleSubHeader}><HeaderSeparator><Typography variant="subtitle2" color="textSecondary" >Aktuelle Werte</Typography></HeaderSeparator></div>
            <DiscreteSlider title="Feldspieler von starkem Club" badge={!(loginStatus.loggedIn && loginStatus.pro)} disabledFlag={!(loginStatus.loggedIn && loginStatus.pro)} settings={settings} setSettings={setSettings} targetValueName="wSubTeamRating" tooltipText="Bewege den Slider weiter nach rechts für mehr Spieler aus starken Teams. Die Teamwertung wird aus aktuellen Wettquoten abgeleitet." />
            <DiscreteSlider title="Keeper von starkem Club" badge={!(loginStatus.loggedIn && loginStatus.pro)} disabledFlag={!(loginStatus.loggedIn && loginStatus.pro)} settings={settings} setSettings={setSettings} targetValueName="wSubTeamRatingKeeper" tooltipText="Bewege den Slider weiter nach rechts für Torhüter aus starken Teams. Die Teamwertung wird aus aktuellen Wettquoten abgeleitet." />
            <DiscreteSlider title="Stammspieler" badge={!(loginStatus.loggedIn && loginStatus.pro)} disabledFlag={!(loginStatus.loggedIn && loginStatus.pro)} settings={settings} setSettings={setSettings} targetValueName="wSubStartingChance" tooltipText="Bewege den Slider weiter nach rechts für Spieler, die wahrscheinlich Stammspieler sind. Die Einschätzung stammt von Experten wie Ligainsider und später auch aus der DFB-Pokal Startelf." />
            <DiscreteSlider title="Hoher aktueller Marktwert" badge={!(loginStatus.loggedIn && loginStatus.pro)} disabledFlag={!(loginStatus.loggedIn && loginStatus.pro)} settings={settings} setSettings={setSettings} targetValueName="wSubCurrentMarketValue" tooltipText="Vielleicht deine stärkste Waffe: Richte dein Team nach dem aktuellen Marktwert aus, welcher die Leistungen in der Vorbereitung und das Know-How der besten deutschen Manager widerspiegelt." />
          </div>
        </AccordionDetails>
      </Accordion>


    </div >
  )
}

export default BasicSettingsSubstitutes
